<template>
  <div class="container">
    <div class="row justify-content-center pt-5 pb-3">
      <div class="col-9 col-xl-7 position-relative g-0">
        <div
          class="
            blended rounded
            d-flex
            flex-column
            justify-content-between
            text-white
            top-0
            start-0
            p-4
            w-100
          "
        >
          <div
            class="
              d-flex
              flex-column
              text-start
              pt-4
              pb-3
              px-3 px-xl-5         
              dynamic-font
            "
          >
            <span><u>Speech Clash</u> merges a mid-core roguelite battler with bite-sized, LLM-powered microlearning, built for productivity-minded players who want to grow while they play. Pick any topic (languages, logic, coding, anything), generate a challenge pack, and earn tactical bonuses by learning: answer right to act, power up your team, and push deeper into the run.</span>
            <hr class="m-4 mx-5" />
            <ul>
              <li>UGC-driven topic packs, generated instantly with built-in AI</li>            
              <li>Answer-Right-to-Act combat: correct answers unlock actions, buffs, and upgrades</li>
              <li>Meta progression: grow your hero roster, collect artifacts, and upgrade abilities in an anime/Futurama-inspired setting</li>
            </ul>
            <hr class="mb-4 mt-2 mx-5" />
            <div class="cta-buttons mt-4 text-center">
              <a href="mailto:speechclash@gmai.com" class="btn btn-primary mx-2">Contact Us</a>
              <a href="https://tally.so/r/w2We2V" class="btn btn-success mx-2">Join Alpha</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-5">
      <div class="col-9 col-xl-7 text-center">
        <img src="../assets/Speech_Clash_Heroes_Set_HD.png" alt="Speech Clash Heroes" style="width: 60%; max-width: 700px; min-width: 300px; height: auto;" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Subscriber",
  data() {
    return { };
  }
};
</script>
<style scoped>
.blended {
  background-image: linear-gradient(0deg, hsla(0, 0%, 0%, .5), hsla(0, 0%, 0%, .5));
  z-index: -1;
  mix-blend-mode: overlay;
}
.dynamic-font {
  font-size: calc(14px + (26 - 14) * ((100vw - 300px) / (3440 - 300)));
}
.cta-buttons .btn {
  padding: 12px 24px;
  border-radius: 5px;
  font-size: 1rem;
  text-decoration: none;
  transition: transform 0.3s ease, background-color 0.3s ease;
}
.cta-buttons .btn:hover {
  transform: scale(1.05);
}
.btn-primary {
  background-color: #007bff;
  color: white;
}
.btn-primary:hover {
  background-color: #0056b3;
}
.btn-success {
  background-color: #28a745;
  color: white;
}
.btn-success:hover {
  background-color: #1e7e34;
}
.btn-warning {
  background-color: #ffc107;
  color: black;
}
.btn-warning:hover {
  background-color: #e0a800;
}

/* Адаптивные стили */
@media (max-width: 768px) {
  .dynamic-font {
    font-size: calc(12px + (20 - 12) * ((100vw - 300px) / (768 - 300)));
  }
  .cta-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  .cta-buttons .btn {
    font-size: 0.9rem;
    padding: 10px 20px;
    width: 90%;
  }
  img {
    width: 80%;
    max-width: 500px;
    min-width: 200px;
  }
}

@media (max-width: 480px) {
  .dynamic-font {
    font-size: 14px;
  }
  .cta-buttons {
    gap: 8px;
  }
  .cta-buttons .btn {
    font-size: 0.8rem;
    padding: 8px 16px;
    width: 95%;
  }
  img {
    width: 90%;
    max-width: 350px;
    min-width: 150px;
  }
}
</style>

